import { gql } from 'apollo-boost';

export const GET_JAMBUILDER_BY_ID = (jbid) => gql`
  query{
    jamBuilderById(_id: "${jbid}"){
      _id
      name
      createdBy{
        _id
        name{
          first
        }
      }
      graph
      configIndex
      deckEndpoint
      templateType
      general
      image
      deck
      yamlUpToDate
    }
  }



`

export const GET_USER_BY_TOKEN = (token) => gql`
  query{
    userMany(filter: {reset_token: "${token}"}){
      _id
      name{
        first
        last
      }
    }
  }
`

export const GET_GAME_OBJECT_BY_ID = (gid) => gql`
  query{
    gameById(_id: "${gid}"){
      _id
      data
    }
  }
`
export const GET_GAME_HISTORY = (gid) => gql`
  query{
    gameById(_id: "${gid}"){
      _id
      history
    }
  }
`

export const GET_GAME_BY_ID = (gid) => gql`
  query{
    gameById(_id: "${gid}"){
      _id
      name
      createdBy{
        _id
        name{
          first
        }
      }
      data
      status
      automation
      participants
      password
      inhand
      deck
      yamlEndpoint
      gameData
      tppData{
        playerPermissions
        currentPhase
        currentTurnStruct
        startEventsRun
      }
      transcript
      build
      builderID
      team
    }
  }
`

export const GET_JAMBUILDER = () => gql`

query{
  jamBuilderMany{
      name
      _id
      createdBy{
        name{
          first
        }
        _id
      }
      graph
      password
      interpreterMessage
      configIndex
      status
      general
      deckEndpoint
      templateType
  
  }

}

`

export const HOME_PAGE_QUERY = (uid) => gql`

query{
  gameMany{
    _id
    name
    automation
    createdBy{
      _id
      name{
        first
      }
    }
    participants
    protected
  }
  
  userById(_id: "${uid}"){
    _id
    name{
      first
      last
    }
  }

  jamBuilderMany(filter:{createdBy: "${uid}"}){
    _id
    name
    createdBy{
      name{
        first
      }
    }
    status
    configIndex
    image
  }
}


`;

export const USER_ACCESS_QUERY = (uid) => gql`
  query{
    userById(_id: "${uid}"){
      _id
      access
      capabilities
      termsCurrent
      satisfiedCriteria{
        id
      }
      completedChallenges
      challengeProgress{
        builderID
        gameId
        furthest{ phase turnStruct }
        peakParticipants
        actionsSeen
      }
    }
  }

`

export const DASHBOARD_QUERY = `
  query($uid: MongoID!){

    userById(_id: $uid){
      access
      capabilities
      satisfiedCriteria{
        id
      }
    }

    jamBuilderMany(
      filter:{
          OR:[
            {general:{privacy: "Public"}},
            {createdBy:$uid}
          ]
       }
    )
    {
        name
        createdBy{
          name{
            first
          }
          _id
        }
        password
        interpreterMessage
        configIndex
        status
        general
        deckEndpoint
        templateType
        _id
        image
    }

    teamMany{
      createdBy{
        name{
        first
        }
        _id
      }
      name
      _id
      members{
        role
        status
        user{
          _id
          displayName
        }
      }
      jams{
        _id
        name
        status
        createdBy{
          name{
            first
          }
        }
        participants
      }
    }
  }

`

// Paginated: a user's own templates (My Templates), newest first.
export const JAMBUILDER_PERSONAL_PAGE = gql`
  query($uid: MongoID!, $skip: Int, $limit: Int){
    jamBuilderPersonalPage(uid: $uid, skip: $skip, limit: $limit){
      _id
      name
      createdBy{ _id name{ first } }
      configIndex
      status
      general
      deckEndpoint
      deckTitle
      templateType
      image
    }
  }
`

// Paginated: public, interpreted community templates, newest first.
export const JAMBUILDER_COMMUNITY_PAGE = gql`
  query($skip: Int, $limit: Int){
    jamBuilderCommunityPage(skip: $skip, limit: $limit){
      _id
      name
      createdBy{ _id name{ first } }
      configIndex
      status
      general
      deckEndpoint
      deckTitle
      templateType
      image
    }
  }
`

// Paginated: admin-curated featured community templates, newest first. Used on the temp
// (IP-based) deployment for the "Featured Community Templates" list — see the
// featuredCommunity flag set by server/scripts/setFeaturedCommunityTemplates.js.
export const JAMBUILDER_FEATURED_COMMUNITY_PAGE = gql`
  query($skip: Int, $limit: Int){
    jamBuilderFeaturedCommunityPage(skip: $skip, limit: $limit){
      _id
      name
      createdBy{ _id name{ first } }
      configIndex
      status
      general
      deckEndpoint
      deckTitle
      templateType
      image
    }
  }
`

// All interpreted templates created by a team's members (the "Templates by team member"
// list). `list` is the team members' user ids.
export const JAMBUILDER_BY_CREATORS = gql`
  query($list: [MongoID]){
    jamBuilderByCreators(list: $list){
      _id
      name
      createdBy{ _id name{ first } }
      configIndex
      status
      general
      deckEndpoint
      deckTitle
      templateType
      image
    }
  }
`

// Paginated: a user's own hosted games, newest first.
export const GAME_PERSONAL_PAGE = gql`
  query($uid: MongoID!, $skip: Int, $limit: Int){
    gamePersonalPage(uid: $uid, skip: $skip, limit: $limit){
      _id
      name
      automation
      createdBy{ _id name{ first } }
      participants
      protected
    }
  }
`

// Teams for the dashboard Team tab (same shape the old DASHBOARD_QUERY.teamMany used).
export const DASHBOARD_TEAMS_QUERY = gql`
  query{
    teamMany{
      createdBy{ name{ first } _id }
      name
      _id
      members{
        role
        status
        user{ _id displayName avatar }
      }
      jams{
        _id
        name
        status
        createdBy{ name{ first } }
        participants
      }
    }
  }
`

export const HOME_PAGE_JAMBUILDER_QUERY = `
  query($uid: MongoID!){

    userById(_id: $uid){
      access
    }

    jamBuilderMany(
      filter:{
          OR:[
            {general:{privacy: "Public"}},
            {createdBy:$uid}
          ]
       }
    )
    {
        name
        createdBy{
          name{
            first
          }
          _id
        }
        graph
        password
        interpreterMessage
        configIndex
        status
        general
        deckEndpoint
        templateType
        _id
        image
    }

    eventMany{
      _id
      name
      createdBy{
        _id
        name{
          first
        }
      }
    }
  }
`



export const HOME_PAGE_GAME_QUERY = `
  query{
    gameMany(filter:{build: null}){
      _id
      name
      automation
      createdBy{
        _id
        name{
          first
        }
      }
      participants
      protected
      data
      status
    }
  }
`

export const GET_GAME_MANY = gql`
  query{
    gameMany{
      _id
      name
      automation
      createdBy{
        _id
        name{
          first
        }
      }
      participants
      protected
    }
  }
`

export const GET_TEAM_MANY = gql`
  query{
    teamMany{
      _id
      name
      createdBy{
        _id
        name{
          first
        }
      }
      members{
        user{
          _id
          name{
            first
          }
        }
        status
        role
      }
      jams{
        _id
      }
    }
  
  }

`

export const GET_USER_RECENTJAMS_DATA = (uid) => gql`
  query{
    userById(_id: "${uid}"){
      _id
      recentJamsData{
        _id
        name
        participants
        createdBy{
          displayName
        }
      
      }
    
    }
  
  }


`


export const USER_RESET_EMAIL = (email) => gql`
    query{
      userResetEmail(email: "${email}"){
        _id
        email
      }
    }
`

export const GET_USER_BY_EMAIL = (email) => gql`

  query{
    userMany(filter: {email: "${email}"}){
      _id
      name{
        first
        last
      }
      email
    }
  }
`

export const GET_USER_BY_EMAIL_SINGLE = gql`
  query($email: String){
    userByEmail(email: $email){
      _id
    }
  }

`

// Current user's profile fields for the dashboard Profile tab.
export const GET_USER_PROFILE = gql`
  query($_id: MongoID!){
    userById(_id: $_id){
      _id
      name{ first }
      avatar
      email
    }
  }
`

export const GET_TEAM_BY_ID = gql`
  query($_id: MongoID!){
    teamById(_id: $_id){
      name
      _id
      members{
        role
        status
        user{
          _id
          displayName
          email
          avatar
        }
      }
    }
  }
`


export const GET_EVENT_BY_ID = (eid) => gql`
  query{
    eventById(_id: "${eid}") {
        _id
        createdBy{
          _id
          name{
            first
          }
        }
        name
        bannerImage
        description
        activity {
          name
          link
          description
        }
      
    }
  }
`

export const GET_USER_BY_ID = (uid) => gql`
  query{
    userById(_id: "${uid}"){
      _id
      name{
        first
        last
      }
      email
    }
  }


`;

export const GET_USER_ACTIVITY = (uid) => gql`
  query{
    userById(_id: "${uid}"){
      recentActivity{
        recentJams{
          _id
          date
        }
        recentTemplates{
          _id
          date
        }
      }
    }

    gameMany(filter:{createdBy:"${uid}"}){
      _id
      name
      automation
      createdBy{
        _id
        name{
          first
        }
      }
      participants
      protected
   }
    
  }
`

export const GET_USER_ACTIVITY_RECENT = (uid) => gql`
query{
  userById(_id: "${uid}"){
    _id
    recentActivity{
      recentJams{
        _id
        date
      
      }
      recentTemplates{
        _id
        date
      }
    }
  }
}
`



export const GET_USER_DECKS = (uid) => gql`
  query{
    userDecksById(_id:"${uid}"){
      customDecks{
        _id
        deckDump
        deckName
        yamlEndpoint
        categoryColorMap
        filterSettings
        published
        listOfCategories,
        listOfLabels
      }
    }
  }
`
export const GET_JAMS_TEMPLATES = `
  query jamBuilderFilter($tempList: [MongoID], $jamList: [MongoID]){
    jamBuilderFilter(list: $tempList){
      name
      _id
      createdBy{
        name{
          first
        }
        _id
      }
      password
      interpreterMessage
      configIndex
      status
      general
      deckEndpoint
      deckTitle
      templateType
    }

    gameFilter(list: $jamList){
      protected
      participants
      name
      createdBy{
        _id
        name{
          first
        }
      }
      _id
      data
    }
  }
`

export const GET_USER_MANY = gql`
    query{
        userMany{
          _id
          name{
              first
          }
        }
    }
`;


export const GET_SESSION_BY_ID = (_id) => gql`
    query{
      jamsessionById(_id:"${_id}"){
        _id
        index
        title
        description
        status
        jamtype
        requirement
        participants{
          _id
          name{
            first
          }
        }
        transcript{
          chats{
            owner
            msg
            _id
            pinned
            cid
            ownerName
            history{
              msg
              editedOn
              editedBy
            }
            quote{
              ownerName
              msg
              cid
            }
          }
          discussion{
            owner
            msg
            _id
            pinned
            cid
            ownerName
            history{
              msg
              editedOn
              editedBy
            }
            quote{
              ownerName
              msg
              cid
            }
          }
        }
        parentFruit
        seed
        ideabank{
          _id
          idea
          ideaBy
          ideaByName
          inspiredBy
          inspiredByName
          fromPhase
          fromChatId
          iteration{
            idea
            ideaBy
            ideaByName
            fromChatId
          }
          generatedOn
        }
        createdBy{
          _id
          name{
            first
          }
        }
        phases{
          _id
          index
          name
          instruction
          field
          settings
          jamId
        }


      }        
    }

`;

export const GET_SESSION_MANY_BY_USER = gql`
    query{
      jamsessionMany{
        _id
        index
        title
        description
        participants{
          _id
          name{
            first
          }
        }
        transcript{
          chats{
            owner
            msg
          }
        }
        seed
        ideabank{
          idea
          ideaBy
          generatedOn
        }
        createdBy{
          _id
          name{
            first
          }
        }
      }

    }
`;



export const GET_SESSION_MANY_BY_CREATOR = (userID) => gql`

    query{
      jamsessionMany(filter:{createdBy: "${userID}"}){
        _id
        index
      }

      projectMany(filter:{createdBy: "${userID}"}){
        _id
        index
      }
    }

`;


export const GET_PHASES_BY_SESSION_ID = (_id) => gql`
    query{


    }

`;



export const GET_PROJECT_MANY = gql`

    query{
      projectMany{
        _id
        index
        title
        createdBy{
          _id
          name{
            first
          }
        }
        description
        workshop
      }
    }

    
`;



export const GET_PROJECT_BY_ID = (_id,userId) => gql`

    query{
      projectById(_id: "${_id}"){
        _id
        index
        title
        member{
          _id
          name{
            first
          }
        }
        createdBy{
          _id
          name{
            first
          }
        }
        jam{
          _id
          createdBy{
            _id
          }
          title
          description
          status
          results
          jamtype
          results
        }
        description
        workshop                 
      }

      jamsessionMany(filter:{createdBy: "${userId}"}){
        _id
        index
      }

      
    }



`;


export const GET_JAM_PROJECT = (_id) => gql`

    query{
      projectByJam(filter:{jamIds: "${_id}"}){
        _id
        createdBy{
          _id
        }
      }      
    }

`;





